import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AcknowledgmentOverlayData {
  language: string;
  hasCompletionDate: boolean;
}

@Component({
  selector: 'app-acknowledgment-overlay',
  templateUrl: './acknowledgment-overlay.component.html',
  styleUrls: ['./acknowledgment-overlay.component.css'],
})
export class AcknowledgmentOverlayComponent implements AfterViewInit {
  @ViewChild('signaturePad') signaturePad: ElementRef<HTMLCanvasElement>;

  drawing = false;
  hasSignature = false;
  language = '';
  hasCompletionDate = false;
  private lastX = 0;
  private lastY = 0;

  constructor(
    public dialogRef: MatDialogRef<AcknowledgmentOverlayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AcknowledgmentOverlayData
  ) {
    this.language = data?.language || '';
    this.hasCompletionDate = !!data?.hasCompletionDate;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.prepareCanvas(), 50);
  }

  startDraw(event: MouseEvent | TouchEvent): void {
    this.drawing = true;
    const point = this.eventPoint(event);
    this.lastX = point.x;
    this.lastY = point.y;
  }

  moveDraw(event: MouseEvent | TouchEvent): void {
    if (!this.drawing) {
      return;
    }
    event.preventDefault();
    const point = this.eventPoint(event);
    const ctx = this.signaturePad?.nativeElement.getContext('2d');
    if (!ctx) {
      return;
    }
    ctx.strokeStyle = '#111';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(point.x, point.y);
    ctx.stroke();
    this.lastX = point.x;
    this.lastY = point.y;
    this.hasSignature = true;
  }

  endDraw(): void {
    this.drawing = false;
  }

  clearSignature(): void {
    const canvas = this.signaturePad?.nativeElement;
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext('2d');
    ctx?.save();
    ctx?.setTransform(1, 0, 0, 1, 0, 0);
    ctx?.clearRect(0, 0, canvas.width, canvas.height);
    ctx?.restore();
    this.hasSignature = false;
  }

  confirm(): void {
    if (!this.hasSignature) {
      return;
    }
    this.dialogRef.close(
      this.signaturePad?.nativeElement.toDataURL('image/png')
    );
  }

  private prepareCanvas(): void {
    const canvas = this.signaturePad?.nativeElement;
    if (!canvas) {
      return;
    }
    const ratio = window.devicePixelRatio || 1;
    const width = canvas.clientWidth || 320;
    const height = canvas.clientHeight || 280;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(ratio, ratio);
  }

  private eventPoint(event: MouseEvent | TouchEvent): { x: number; y: number } {
    const canvas = this.signaturePad?.nativeElement;
    if (!canvas) {
      return { x: 0, y: 0 };
    }
    const rect = canvas.getBoundingClientRect();
    const touch =
      (event as TouchEvent).touches && (event as TouchEvent).touches[0];
    const clientX = touch ? touch.clientX : (event as MouseEvent).clientX;
    const clientY = touch ? touch.clientY : (event as MouseEvent).clientY;
    return { x: clientX - rect.left, y: clientY - rect.top };
  }
}
